import { render, staticRenderFns } from "./ReviewTypeDetailsPage.vue?vue&type=template&id=27ebf31e&"
import script from "./ReviewTypeDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ReviewTypeDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTypeDetailsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports